var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChallenges(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.5,81.79H88L66.16,35.16V22.5H85A2.5,2.5,0,0,0,87.5,20V7.5A2.5,2.5,0,0,0,85,5H63.66a2.5,2.5,0,0,0-2.5,2.5V35L44.73,61.28l-11.5-8.17a2.48,2.48,0,0,0-3.56.71l-17.48,28H7.5a2.5,2.5,0,0,0,0,5h85a2.5,2.5,0,0,0,0-5ZM82.5,17.5H66.16V10H82.5Zm-50,41.22L44,66.89a2.48,2.48,0,0,0,1.94.42,2.53,2.53,0,0,0,1.63-1.13L63.35,40.93,82.5,81.79H18.08Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallenges);
export default __webpack_public_path__ + "static/media/challenges.6771eca27d3b79573eb69c1e535a28b3.svg";
export { ForwardRef as ReactComponent };